import { useEffect, useRef } from 'react';
import { useOfflineCheck } from 'hooks/useOfflineCheck';

const UpdateAlert = () => {
  const updateAvailable = useRef(false);
  const isOffline = useOfflineCheck();

  // Poll for version changes
  useEffect(() => {
    const checkUpdate = () => {
      fetch(`/version.txt?_=${Date.now()}`, {
        headers: {
          mode: 'no-cors',
        },
      })
        .then((res) => res.text())
        .then((version) => {
          if (
            !version.includes('<!') &&
            version.trim() !== process.env.REACT_APP_COMMIT_REF
          ) {
            updateAvailable.current = true;
          }
        })
        // eslint-disable-next-line no-console
        .catch((e) => console.log(e));
    };

    if (!isOffline) checkUpdate();

    let interval;
    if (!isOffline) interval = setInterval(checkUpdate, 3000);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isOffline]);

  // Intercept navigation — on next route change, do a full page reload
  useEffect(() => {
    const originalPushState = window.history.pushState.bind(window.history);
    const originalReplaceState = window.history.replaceState.bind(
      window.history
    );

    const reloadForUpdate = (url) => {
      if (!updateAvailable.current || !url) return false;

      // Unregister service workers so reload fetches fresh content
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          for (const registration of registrations) {
            registration.unregister();
          }
          window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
      return true;
    };

    window.history.pushState = function (state, title, url) {
      if (reloadForUpdate(url)) return;
      return originalPushState(state, title, url);
    };

    window.history.replaceState = function (state, title, url) {
      if (reloadForUpdate(url)) return;
      return originalReplaceState(state, title, url);
    };

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return null;
};

export default UpdateAlert;
